<template>
    <v-dialog v-model="dialog" :width="width?width:500" :persistent="true">
        <v-card>
            <div class="header-container">
                <p class="header-title">{{ header }}</p>
                <div>
                    <div class="round-btn" @click="$emit('onClose')"><i class="fas fa-times" /></div>
                </div>
            </div>

            <div class="card-content">
                <slot />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: Boolean,
        width: String,
        header: String
    }
};
</script>

<style scoped>
.header-container{
	background-color: var(--main-color);
	padding: 8px 16px;
	font-size: 16px;
	color: var(--pure-white);
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header-title{
	margin: 0;
    color: white;
}
.card-content{
    padding: 16px;
	color: rgba(0, 0, 0, 0.6);
	font-size: 15px;
	border-bottom: 1px solid var(--dialog-separator-line);
}
.card-action{
	padding: 16px;
}
.close-dialog-btn{
	border-radius: 50%;
	padding: 9px;
	background-color: var(--main-color-orange);
	width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
	justify-content: center;
	font-size: 10px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/Dialog/Dialog.vue